import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Badge, BadgeOrigin, Tooltip, useTheme } from '@mui/material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'

import { EAccountSubscriptionPlans } from 'src/types'
import { useStyles } from './styles'

interface IProps {
  children: ReactNode
  subscription: EAccountSubscriptionPlans
  origin?: BadgeOrigin
  showAI?: boolean
}

export const SubscriptionBadge = ({ children, subscription, origin, showAI = false }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  const innerBadge = (
    <Badge
      overlap="circular"
      anchorOrigin={
        origin || {
          vertical: 'top',
          horizontal: 'right',
        }
      }
      badgeContent={
        <Tooltip title={`${t('subscription-header-title.v')}: ${subscription}`}>
          <div className={classes.tooltipWrapper}>
            <span
              className={classes.tooltip}
              style={{
                backgroundColor:
                  subscription === EAccountSubscriptionPlans.free
                    ? 'grey'
                    : subscription === EAccountSubscriptionPlans.plus
                      ? 'forestgreen'
                      : subscription === EAccountSubscriptionPlans.premium
                        ? 'gold'
                        : subscription === EAccountSubscriptionPlans.enterprise
                          ? 'deepskyblue'
                          : 'red',
              }}
            />
          </div>
        </Tooltip>
      }
    >
      {children}
    </Badge>
  )

  if (showAI) {
    return (
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        badgeContent={<AutoAwesomeIcon fontSize="medium" sx={{ fill: 'deepskyblue' }} />}
      >
        {innerBadge}
      </Badge>
    )
  }

  return innerBadge
}
